// EN
export const accomMgmt = {
  common: {
    cancel: "Annuler",
    save: "Enregistrer",
    update: "Mettre à jour",
    back: "Retour",
    continue: "Continuer",
    optional: "(optionnel)",
    optionalPlaceholder: "Optionnel",
    processing: "Traitement en cours...",
    name: "Nom",
    description: "Description",
    nameRequired: "Le nom est obligatoire.",
  },

  type: {
    apartment: "Appartement touristique",
    hotel: "Hôtel",
    camping: "Camping",
    villa: "Villa",
  },

  step: {
    type: "Type",
    structure: "Structure",
    accommodation: "Hébergement",
  },

  step1: {
    title: "Quel type d'hébergement possédez-vous ?",
    subtitle: "Sélectionnez le type d'hébergement.",
    subtitleQuota: "Seuls les types disposant encore d'un quota sur votre forfait seront actifs.",
    subtitleFirst: "Comme il s'agit de votre premier hébergement, vous pouvez choisir n'importe quel type.",
    remaining: "restant : {count}",
    loadingQuota: "Chargement du quota de votre forfait…",
  },

  step2: {
    title: "Configurez votre hébergement",
    subtitle:
      "Décidez s'il s'agira d'un hébergement autonome ou d'un hébergement à plusieurs calendriers (plusieurs unités au sein d'un même hébergement).",
    singleTitle: "Un espace unique",
    singleChip: "1 calendrier",
    singleDesc: "Louez tout l'appartement avec un seul calendrier.",
    groupedTitle: "Plusieurs espaces",
    groupedChip: "Plusieurs calendriers",
    groupedDesc: "Vous louez plusieurs espaces indépendants au sein de l'appartement",
  },

  step3: {
    title: "Configurez l'hébergement principal",
    subtitle:
      "Ce sera le “conteneur” (Annonce) qui regroupe plusieurs calendriers. Ex. “Suite du Château”.",
    panelTitle: "Choisissez une option",
    availableCount: "Vous avez {count} hébergements groupés disponibles.",
    noneAvailable: "Aucune annonce groupée disponible pour ce type (créez-en une nouvelle).",
    newTitle: "Créer un nouvel hébergement principal",
    newDesc: "Vous définissez le nom de l'hébergement principal.",
    nameLabel: "Nom de l'hébergement principal",
    namePlaceholder: "Ex. Suite du Château",
    nameHelp: "Ce nom sera enregistré et vous pourrez regrouper plusieurs calendriers.",
    minChars: "Saisissez au moins 3 caractères.",
    existingTitle: "Ajouter à un hébergement existant",
    existingDesc: "L'unité sera intégrée à un hébergement que vous avez déjà créé.",
    selectLabel: "Sélectionnez l'hébergement",
    selectPlaceholder: "Sélectionnez un hébergement…",
    listingOption: "{name} · {units} unité(s)",
    ready: "Prêt",
    noneForType: "Vous n'avez aucun hébergement groupé disponible pour ce type.",
    tip: "Astuce : ce “principal” sera le conteneur auquel la nouvelle unité est ajoutée.",
  },

  preview: {
    tab: "votrehebergement",
    perNight: "/nuit",
    book: "Réserver",
    locationPlaceholder: "Pays, ville, rue",
    guests: "{count} client | {count} clients",
    bedrooms: "{count} chambre | {count} chambres",
    bathrooms: "{count} salle de bain | {count} salles de bain",
    amenitiesTitle: "Équipements",
    amenitiesEmpty: "Sélectionnez pour ajouter des équipements à votre hébergement",
    locationTitle: "Emplacement",
    locationEmpty: "Définissez l'emplacement",
    descriptionTitle: "Description",
    descriptionEmpty: "Sélectionnez pour ajouter une description à votre hébergement",
    namePlaceholder: "Nom de l'hébergement",
    amenity: {
      air_conditioning: "Climatisation",
      heating: "Chauffage central",
      parking: "Place de parking",
      oven: "Four et plaques de cuisson",
      pets_allowed: "Animaux acceptés",
      wifi: "Internet WiFi",
      essentials: "Essentiels",
      washing_machine: "Machine à laver",
      children_allowed: "Enfants acceptés",
      refrigerator: "Réfrigérateur",
    },
  },

  amenities: {
    title: "Équipements et commodités",
    subtitle: "Indiquez aux clients ce que propose votre hébergement pour qu'ils sachent à quoi s'attendre.",
    searchPlaceholder: "Rechercher un équipement…",
    selectedCount:
      "{count} équipement sélectionné | {count} équipements sélectionnés",
    noResults: 'Aucun équipement trouvé pour "{search}".',
    cat: {
      all: "Tous",
      basics: "Essentiels",
      bathroom: "Salle de bain",
      bedroom: "Chambre et buanderie",
      kitchen: "Cuisine et salle à manger",
      outdoor: "Extérieur",
      leisure: "Loisirs et divertissement",
      safety: "Sécurité",
      family: "Familles",
      parking: "Parking",
      services: "Services",
      connectivity: "Connectivité",
      accessibility: "Accessibilité",
    },
    item: {
      wifi: "WiFi",
      essentials: "Essentiels",
      air_conditioning: "Climatisation",
      heating: "Chauffage",
      indoor_fireplace: "Cheminée intérieure",
      hot_water: "Eau chaude",
      hangers: "Cintres",
      bed_linen: "Linge de lit",
      towels: "Serviettes",
      shampoo: "Shampooing",
      shower_gel: "Gel douche",
      conditioner: "Après-shampooing",
      hair_dryer: "Sèche-cheveux",
      bathtub: "Baignoire",
      bidet: "Bidet",
      jacuzzi: "Jacuzzi",
      outdoor_shower: "Douche extérieure",
      washing_machine: "Machine à laver",
      dryer: "Sèche-linge",
      iron: "Fer à repasser",
      clothes_drying_rack: "Étendoir à linge",
      extra_pillows: "Oreillers et couvertures supplémentaires",
      wardrobe: "Rangement pour vêtements",
      blackout_curtains: "Stores ou rideaux occultants",
      nearby_laundry: "Laverie à proximité",
      oven: "Four",
      refrigerator: "Réfrigérateur",
      freezer: "Congélateur",
      microwave: "Micro-ondes",
      dishwasher: "Lave-vaisselle",
      cooking_basics: "Ustensiles de cuisine de base",
      plates_cutlery: "Vaisselle et couverts",
      wine_glasses: "Verres à vin",
      coffee_maker: "Cafetière",
      coffee: "Café",
      kettle: "Bouilloire",
      toaster: "Grille-pain",
      blender: "Mixeur",
      rice_cooker: "Cuiseur à riz",
      bread_maker: "Machine à pain",
      mini_fridge: "Mini-réfrigérateur",
      stovetop: "Plaque de cuisson",
      dining_table: "Table à manger",
      baking_sheet: "Plaque à pâtisserie",
      bbq_grill: "Barbecue",
      bbq_utensils: "Ustensiles de barbecue",
      outdoor_kitchen: "Cuisine extérieure",
      outdoor_dining: "Coin repas extérieur",
      breakfast: "Petit-déjeuner",
      pool: "Piscine",
      shared_pool: "Piscine partagée",
      garden: "Jardin",
      patio_balcony: "Terrasse ou balcon",
      outdoor_furniture: "Mobilier d'extérieur",
      sun_loungers: "Transats",
      hammock: "Hamac",
      fire_pit: "Brasero extérieur",
      shared_fireplace: "Cheminée en espace commun",
      sauna: "Sauna",
      beach_essentials: "Essentiels de plage",
      beach_access: "Accès à la plage",
      lake_access: "Accès au lac",
      resort_access: "Accès au complexe",
      waterfront: "Bord de l'eau",
      dock: "Ponton pour bateau",
      kayak: "Kayak",
      bikes: "Vélos",
      ski_slope: "Piste de ski",
      outdoor_playground: "Aire de jeux extérieure",
      tv: "Télévision",
      sound_system: "Système audio",
      record_player: "Tourne-disque",
      piano: "Piano",
      gym: "Salle de sport",
      exercise_equipment: "Équipement de sport",
      games: "Jeux de société",
      giant_games: "Jeux géants",
      pool_table: "Billard",
      ping_pong: "Table de ping-pong",
      bowling: "Piste de bowling",
      arcade: "Jeux d'arcade",
      minigolf: "Minigolf",
      batting_cage: "Cage de frappe",
      ice_rink: "Patinoire de hockey",
      laser_tag: "Laser game",
      skate_ramp: "Rampe de skate",
      climbing_wall: "Mur d'escalade",
      game_console: "Console de jeux",
      books: "Livres et lectures",
      cinema: "Cinéma",
      themed_room: "Chambre à thème",
      smoke_detector: "Détecteur de fumée",
      co_detector: "Détecteur de monoxyde de carbone",
      fire_extinguisher: "Extincteur",
      first_aid_kit: "Trousse de premiers secours",
      fire_guard: "Pare-feu",
      safe: "Coffre-fort",
      gated_community: "Résidence sécurisée",
      security_cameras: "Caméras de sécurité",
      children_allowed: "Enfants acceptés",
      crib: "Lit bébé",
      travel_cot: "Lit parapluie",
      baby_bath: "Baignoire pour bébé",
      baby_safety_gates: "Barrières de sécurité pour bébé",
      changing_table: "Table à langer",
      high_chair: "Chaise haute",
      children_plates: "Vaisselle et couverts pour enfants",
      children_books_toys: "Livres et jouets pour enfants",
      kids_bikes: "Vélos pour enfants",
      outlet_covers: "Cache-prises",
      table_corner_guards: "Protège-coins de table",
      window_guards: "Protections de fenêtres",
      baby_monitor: "Babyphone",
      children_game_room: "Salle de jeux pour enfants",
      babysitter_recommendations: "Recommandations de baby-sitters",
      parking: "Parking gratuit sur place",
      free_street_parking: "Stationnement gratuit dans la rue",
      paid_parking_on_premises: "Parking payant sur place",
      paid_parking_off_premises: "Parking payant à proximité",
      ev_charger: "Borne de recharge pour voiture électrique",
      e_bike_charger: "Chargeur pour vélo électrique",
      pets_allowed: "Animaux acceptés",
      long_term_stays: "Disponible pour longs séjours",
      luggage_dropoff: "Dépôt de bagages autorisé",
      cleaning_during_stay: "Ménage disponible pendant le séjour",
      concierge: "Conciergerie",
      cleaning_products: "Produits de nettoyage",
      recycling: "Bacs de recyclage",
      compactor: "Compacteur de déchets",
      compost: "Bac à compost",
      solar_panels: "Panneaux solaires",
      workspace: "Espace de travail",
      private_entrance: "Entrée privée",
      private_lounge: "Salon privé",
      mosquito_net: "Moustiquaire",
      ceiling_fan: "Ventilateur de plafond",
      portable_fans: "Ventilateurs portables",
      ethernet: "Connexion Ethernet",
      mobile_wifi: "WiFi mobile",
      single_floor: "Hébergement de plain-pied",
      elevator: "Ascenseur",
    },
  },

  room: {
    createTitle: "Enregistrer un type de chambre",
    editTitle: "Mettre à jour le type de chambre",
    namePlaceholder: "Ex. Chambre double",
    countLabel: "Nombre de chambres de ce type",
    countPlaceholder: "Ex. 20",
    countHint: "Il s'agit de l'inventaire total pour ce type. Ex. “Double” = 20 chambres.",
    capacityLabel: "Capacité totale (clients max.)",
    capacityPlaceholder: "Ex. 5",
    capacityHint:
      "Il s'agit de la limite réelle de clients. Même si vous définissez des maximums par catégorie, le total prévaut.",
    maxAdults: "Adultes max.",
    maxChildren: "Enfants max.",
    maxInfants: "Bébés max.",
    importantLabel: "Important :",
    capacityNote: "il s'agit de plafonds par catégorie. Le total autorisé est défini par “Capacité totale”.",
    physicalTitle: "Chambres physiques (RoomInstances)",
    physicalDesc: "Activez-le si vous souhaitez gérer les 101/102, la maintenance et les serrures par chambre.",
    generateLabel: "Générer/Ajuster automatiquement les chambres physiques",
    generatorTitle: "Générateur de codes",
    prefixLabel: "Préfixe",
    prefixPlaceholder: "Ex. 10 ou A-",
    prefixHint: "Ex. préfixe “10” + début 1 => 101,102...",
    startLabel: "Début",
    paddingLabel: "Remplissage",
    paddingHint: "Ex. remplissage 3 => 001,002,003",
    nameModeType: "Type uniquement",
    nameModeTypeCode: "Type + code",
    defaultDescLabel: "Description par défaut",
    willCreatePre: "Jusqu'à",
    willCreatePost: "chambres physiques seront créées ou ajustées automatiquement.",
    errors: {
      saveFallback: "Erreur lors de l'enregistrement du type de chambre.",
      capacityMin: "La capacité totale doit être d'au moins 1.",
      adultsMin: "Au moins 1 adulte doit être autorisé.",
      adultsMax: "La limite d'adultes ne peut pas dépasser la capacité totale.",
      childrenRange: "La limite d'enfants doit être comprise entre 0 et la capacité totale.",
      infantsRange: "La limite de bébés doit être comprise entre 0 et la capacité totale.",
      roomsMin: "Le nombre de chambres doit être d'au moins 1.",
      notAuth: "Utilisateur non authentifié.",
    },
    toasts: {
      updated: "Type mis à jour.",
      created: "Type créé.",
      roomsSynced: "Chambres physiques générées/ajustées avec succès.",
    },
  },

  rate: {
    registerHeader: "Enregistrer un type de chambre",
    editHeader: "Mettre à jour le tarif - {name}",
    createHeader: "Enregistrer le tarif - {name}",
    processing: "Traitement en cours, veuillez patienter.",
    general: "Général",
    namePlaceholder: "Nom personnalisé",
    validityLabel: "Période de validité",
    permanent: "Permanent",
    custom: "Personnalisé",
    startDatePlaceholder: "Date de début",
    endDatePlaceholder: "Date de fin",
    validityNoteCustom: "Période de validité du tarif (optionnelle)",
    validityNotePermanent: "Tarif valable en permanence",
    pricePerNight: "Prix par nuit",
    taxIncluded: "Taxes incluses",
    occupancy: "Occupation",
    guestsNumber: "Nombre de clients",
    minStay: "Séjour minimum",
    minStayNote: "Nuits minimum à facturer",
    maxStay: "Séjour maximum",
    maxStayNote: "Limite de nuits réservables",
    errors: {
      rangeRequired: "Vous devez sélectionner une plage de dates valide",
      startAfterEnd: "La date de début ne peut pas être postérieure à la date de fin",
      minStay:
        "Le séjour minimum est de {minStay} nuits, mais la plage sélectionnée compte {nights} nuits",
    },
  },
};